import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface DeleteBillingPartyMemberInput {
    id: number
}

interface DeleteBillingPartyMemberData {
    deleteBillingPartyMember: BillingParty
}

const DELETE_BILLING_PARTY_MEMBER_MUTATION = gql`
    mutation deleteBillingPartyMember($id: Int!) {
        deleteBillingPartyMember(id: $id) {
            id
        }
    }
`;

const deleteBillingPartyMember = () => useMutation<DeleteBillingPartyMemberData, DeleteBillingPartyMemberInput>(
    DELETE_BILLING_PARTY_MEMBER_MUTATION,
    {
        update: updateCacheByType('BillingPartyMember'),
    }
);

export default deleteBillingPartyMember;